import MainFeedDetailsComoponent from "./MainFeedDetailsComoponent";

export default MainFeedDetailsComoponent